var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.515,
    height: 18.714,
    viewBox: "0 0 15.515 18.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "play-icon",
    className: "cls-1",
    d: "M6.587-.741h0A4.31,4.31,0,0,1,9.15.1L16.3,5.34v.026a4.337,4.337,0,0,1-.306,6.746L9.15,17.131a4.3,4.3,0,0,1-2.568.842,4.333,4.333,0,0,1-4.333-4.34V3.593A4.337,4.337,0,0,1,6.587-.741ZM14.8,6.1,8.263,1.307A2.819,2.819,0,0,0,6.587.759,2.837,2.837,0,0,0,3.75,3.594v10.04a2.833,2.833,0,0,0,4.512,2.287L15.106,10.9a2.837,2.837,0,0,0,0-4.575L14.8,6.1Z",
    transform: "translate(-2.25 0.741)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.3f6dbc657f26dc45c53bdc8be4fa1853.svg";
export { ForwardRef as ReactComponent };